'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    padding: 60px 1.3em;\n  '], ['\n    padding: 60px 1.3em;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    padding: 60px 14px 0;\n  '], ['\n    padding: 60px 14px 0;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    padding-top: 20px;\n  '], ['\n    padding-top: 20px;\n  ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HubInfoContainer = _styledComponents2.default.div.withConfig({
  displayName: 'HubInfoContainer'
})(['max-width:1280px;margin:0 auto;margin-top:-458px;padding:45px 80px 0;', ';', ' ', ''], _responsiveBreakpoints2.default.tablet(_templateObject), _responsiveBreakpoints2.default.tabletPortrait(_templateObject2), _responsiveBreakpoints2.default.phone(_templateObject3));

exports.default = HubInfoContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/HubInfoContainer.js
// module id = 254
// module chunks = 3 4